module.exports = __webpack_public_path__ + "img/2.25fdad28.jpg";